import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";

const brl = (cents) =>
  (Number(cents || 0) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
const pct = (value) =>
  value === null || value === undefined
    ? "Sem amostra"
    : `${Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 4 })}%`;

export default function AdminFluxopayProviderFees() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = async () => {
    setLoading(true);
    setError("");
    try {
      setData((await api.get("/api/admin/fluxopay/provider-metrics")).data);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Não foi possível carregar os custos conciliados do Asaas.",
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  return (
    <section className="afxp-card">
      <header>
        <div>
          <small>CUSTO OPERACIONAL</small>
          <h3>Taxas efetivas do provedor</h3>
        </div>
        <button className="afxp-secondary" onClick={load} disabled={loading}>
          <FontAwesomeIcon icon={faRotate} />{" "}
          {loading ? "Atualizando..." : "Atualizar"}
        </button>
      </header>
      <p className="afxp-explanation">
        Valores apurados nas cobranças efetivamente conciliadas com o Asaas. O
        percentual é uma média ponderada: custo total dividido pelo volume bruto
        conciliado.
      </p>
      {error && (
        <p className="afxp-warning">
          <FontAwesomeIcon icon={faCircleExclamation} />
          {error}
        </p>
      )}
      {(data?.metrics || []).map((metric) => (
        <div className="afxp-provider-fee" key={metric.key}>
          <div>
            <b>{metric.label}</b>
            <small>
              {metric.transactions} transação(ões) · custo{" "}
              {brl(metric.provider_fee_cents)} · volume{" "}
              {brl(metric.gross_cents)}
            </small>
          </div>
          <strong>{pct(metric.effective_percentage)}</strong>
        </div>
      ))}
      {data && (
        <div className="afxp-provider-fee">
          <div>
            <b>Transferências</b>
            <small>
              {data.transfers.transactions} transferência(s) concluída(s) ·
              custo total {brl(data.transfers.provider_fee_cents)}
            </small>
          </div>
          <strong>
            {data.transfers.average_fee_cents === null
              ? "Sem amostra"
              : `${brl(data.transfers.average_fee_cents)} média`}
          </strong>
        </div>
      )}
      {!loading &&
        !error &&
        (data?.metrics || []).every((item) => item.transactions === 0) && (
          <p className="afxp-warning">
            <FontAwesomeIcon icon={faCircleExclamation} />
            Ainda não existem cobranças conciliadas suficientes para calcular o
            custo real do provedor.
          </p>
        )}
    </section>
  );
}
